import axios from "axios";
import { ResponseStatusCode } from "../types/global";
import history from "./history";
import RescoConfig from "./rescoConfig";
import RescoStorage from "./rescoStorage";

const axiosInstance = axios.create({
  baseURL: `${RescoConfig.ResWebApiUrl}`,
  timeout: 60000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response !== undefined && error.response.status === ResponseStatusCode.UNAUTHORIZED) {
      RescoStorage.removeSession();
      history.push("/register");
    }
    return error;
  }
);

export { axiosInstance };

